import React, { useEffect, useState } from "react";
import { Container, Box, Button } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Section from "../components/Section";
import ProgressStepsDeg from "../components/ProgressStepsDeg";
import axios from "axios";
import logo from "../assets/img/logo_with_text.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import LanguageSwitcher from "../components/LanguageSwitcher";
import ReturnToHome from "../components/ReturnToHome";
import IndicatorePagina from "../components/IndicatorePagina";
const theme = createTheme({
  palette: {
    mode: "light",
  },
});
const QuestionarioDeg = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const dip = queryParameters.get("dip");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [sections, setSections] = useState([]);
  const [isloaded, setIsLoaded] = useState(false);
  const [ip, setIP] = useState("");
  const getIp = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setIP(res.data.ip);
  };
  const fetchSections = async () => {
    const response = await axios.get("api/structDeg/getSurvey", {
      params: { dipartimento: dip },
    });
    setSections(response.data);

    setRatings(
      response.data.flatMap((section, sectionIndex) =>
        section.questions.map((_, questionIndex) => ({
          section: section.id,
          question: questionIndex,
          answer: "",
          answerId: -1,
        }))
      )
    );

    setIsLoaded(true);
  };
  useEffect(() => {
    getIp();

    fetchSections();
  }, []);

  // Crea una lista di indirizzi ip della categoria 92.223.173.192/28
  const internalIps = [
    "92.223.173.192",
    "92.223.173.193",
    "92.223.173.194",
    "92.223.173.195",
    "92.223.173.196",
    "92.223.173.197",
    "92.223.173.198",
    "92.223.173.199",
    "92.223.173.200",
    "92.223.173.201",
    "92.223.173.202",
    "92.223.173.203",
    "92.223.173.204",
    "92.223.173.205",
    "92.223.173.206",
    "92.223.173.207",
  ];

  const [activeStep, setActiveStep] = useState(0);
  const [ratings, setRatings] = useState([]);

  const handleRatingChange = (sectionIndex, questionIndex, option) => {
    setRatings((prevRatings) => {
      const updatedRatings = prevRatings.map((rating) =>
        rating.section === sectionIndex && rating.question === questionIndex
          ? { ...rating, answer: option.description, answerId: option.id }
          : rating
      );
      return updatedRatings;
    });
  };

  const handleNext = () => {
    if (activeStep === 0 && ratings[0].answer === "") {
      setError("Questi campi sono obbligatori");
      return;
    }
    if (activeStep < sections.length - 1) {
      setError("");
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      // Invia i dati all'APIVisualizza le risposte nel console log come esempio
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleSubmit = async () => {
    const data = {
      dipartimento: dip,
      interno: internalIps.indexOf(ip) > -1 ? true : false,
      ratings: ratings,
    };
    try {
      // Modifica l'URL e le opzioni della richiesta in base alle specifiche della tua API
      const response = await fetch("api/questDeg/insertSurvey", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(
          "Si è verificato un errore durante l'invio delle risposte"
        );
      }
      // Reindirizza l'utente alla pagina iniziale
      navigate("/degenti", {
        state: { success: true },
      });
    } catch (error) {
      // Gestisci gli errori (es. mostrare un messaggio di errore)
      console.error("Errore:", error.message);
    }
  };

  const styles = {
    questionnaireContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-evenly",
      minHeight: "100vh",
      padding: "1rem",
      backgroundColor: theme.palette.background.default,
    },
    box: {
      width: "100%",
      maxWidth: "800px",
      borderRadius: "8px",
      backgroundColor: theme.palette.action.hover,
      padding: "2rem",
      boxShadow: "0 3px 5px rgba(0, 0, 0, 0.3)",
    },
    button: {
      marginRight: "1rem",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    logo: {
      minHeight: "150px",
      maxHeight: "150px",
      margin: "2rem",
    },
  };
  return (
    <>
      <ReturnToHome />
      <LanguageSwitcher />
      {isloaded ? null : (
        <Box
          sx={{
            display: "flex",
            minHeight: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {isloaded ? (
        <Container maxWidth="md" sx={styles.questionnaireContainer}>
          <Box sx={styles.logo}>
            <img src={logo} alt="Logo" style={{ height: "150px" }} />
          </Box>
          <Box sx={styles.box}>
            <ProgressStepsDeg
              activeStep={activeStep}
              steps={sections.map((section) => section.title)}
            />
            <Section
              sectionIndex={sections[activeStep].id}
              title={sections[activeStep].title}
              questions={sections[activeStep].questions}
              handleRatingChange={handleRatingChange}
              ratings={ratings}
              sections={sections}
              error={error}
            />
            <Box mt={3} sx={styles.buttonContainer}>
              {activeStep > 0 && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleBack}
                >
                  {t("Indietro")}
                </Button>
              )}
              <Box>
                {activeStep < sections.length - 1 && (
                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    onClick={handleNext}
                    sx={styles.button}
                  >
                    {t("Avanti")}
                  </Button>
                )}
                {activeStep === sections.length - 1 && (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                  >
                    {t("Invia")}
                  </Button>
                )}
              </Box>
            </Box>
            <IndicatorePagina dp={dip} />
          </Box>
        </Container>
      ) : null}
    </>
  );
};

export default QuestionarioDeg;
